import { PreviewContentChildType } from './types';

export const childClampState = (
    previewChildCount: PreviewContentChildType['previewChildCount'],
    componentChildrenCount: number,
) => {
    return previewChildCount < componentChildrenCount;
};
